/* tslint:disable */
/* eslint-disable */
export enum TagType {
  Marketing = 'MARKETING',
  Allergy = 'ALLERGY',
  Dietary = 'DIETARY',
  UeTaxCategory = 'UE_TAX_CATEGORY',
  Promotional = 'PROMOTIONAL',
  Legal = 'LEGAL'
}
